module.exports = __webpack_public_path__ + "map_footer_ru.png?f0bc513aad2bd22718c1b2eda4bc1fce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map_footer_ru.png
// module id = 261
// module chunks = 0